import {
    CREATE_TAX_RETURN,
    INVALIDATE_TAX_RETURN,
    RECEIVE_TAX_RETURN,
    RECEIVE_TAX_RETURN_DEDUCTION,
    REQUEST_TAX_RETURN,
} from '../actions'
import { updateOrAddItemById } from '../helpers'

export default (
    state = {
        fetchSuccessful: null,
        isCreating: null,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case CREATE_TAX_RETURN:
            return { ...state, isCreating: true }

        case REQUEST_TAX_RETURN:
            return { ...state, shouldFetch: false }

        case RECEIVE_TAX_RETURN:
            return { ...state, ...data }

        case RECEIVE_TAX_RETURN_DEDUCTION: {
            const { deductions } = state

            return { ...state, deductions: updateOrAddItemById(deductions, data) }
        }

        case INVALIDATE_TAX_RETURN:
            return { ...state, shouldFetch: true }

        default:
            return state
    }
}
